import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/domains/organizations';
import { brandRepository } from '../repositories/brand.repository';
import { brandKeys } from '../services/brand.keys';
import type { Brand } from '../types/brand.types';

export type { Brand };

export function useBrands() {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id;

  return useQuery({
    queryKey: brandKeys.all(orgId),
    queryFn: async (): Promise<Brand[]> => {
      return brandRepository.getBrands(orgId);
    },
    refetchOnWindowFocus: true,
  });
}
